<template>

  <component :is="tag" class="badge badge-pill" :class="`badge-${type}`">
    <slot></slot>
  </component>
</template>
<script>
export default {
  name: 'badge',
  props: {
    tag: {
      type: String,
      default: 'span',
      description: 'Badge tag'
    },
    type: {
      type: String,
      default: 'default',
      description: 'Badge type (primary|info|success|warning|danger|default)'
    }
  }
};
</script>
<style></style>
